"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var hasChildren = function (element) {
    return (0, react_1.isValidElement)(element) &&
        Boolean(element.props.children);
};
exports.default = hasChildren;
//# sourceMappingURL=hasChildren.js.map